import { useLinked } from "@type-r/react";
import { Column, Columns, Flex } from "lqx-react";
import React from "react";
import {
  BackButton, CancelButton, ConfirmationButton, RightAlignedButtons, StartOverButton, WorkflowBody, WorkflowFooter, WorkflowTitle
} from "../../shared";
import { UploadSection } from "../common/upload-section";
import { ImportTemplateDetails, Mapping } from "../models/import-template-details";

export const UploadImportTemplateStep = ({ next, back, cancel, startOver, importTemplateDetails }
  : { next?, back?, cancel?, startOver?, importTemplateDetails?: ImportTemplateDetails }) => {
  const $file = useLinked(importTemplateDetails.file);
  const $delimiter = useLinked(importTemplateDetails.delimiter);

  const alowedExtensions = [".csv", ".xlsx", ".pdf", ".xls", ".txt"];
  const isValidFile = $file.value && alowedExtensions.filter(ext => $file.value.name.toLowerCase().endsWith(ext)).length > 0;

  return (
    <>
      <WorkflowTitle>
        Step 2: Upload Sample Files to Review Results
      </WorkflowTitle>
      <WorkflowBody>
        <UploadSection $file={$file} $delimiter={$delimiter} isValidFile={isValidFile}/>
      </WorkflowBody>
      <WorkflowFooter>
        <Columns>
          <Column>
            <Flex row>
              <CancelButton color="primary" onClick={cancel}>Cancel</CancelButton>
              <StartOverButton color="primary" onClick={startOver}>Start Over</StartOverButton>
            </Flex>
          </Column>
          <Column>
            <RightAlignedButtons>
              <BackButton color="primary" onClick={back}>Back</BackButton>
              <ConfirmationButton
                disabled={$file.value &&
                  (($file.value.name.split('.').pop() === 'txt' && $delimiter.value.length > 0) || $file.value.name.split('.').pop() !== 'txt') && isValidFile
                  ? false : true}
                onClick={() => next(
                  {
                    originalFileName: $file.value.name,
                    file: $file.value,
                    delimiter: $file.value.name.split('.').pop() === 'txt' || $file.value.name.split('.').pop() === 'csv' ? $delimiter.value : '',
                    mappings: importTemplateDetails.file === null || importTemplateDetails.file === $file.value
                      ? importTemplateDetails.mappings
                      : [] as Mapping[]
                  })}>Next: Map Fields</ConfirmationButton>
            </RightAlignedButtons>
          </Column>
        </Columns>
      </WorkflowFooter>
    </>);
};
